import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://grixhsjyudfmonkschlt.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdyaXhoc2p5dWRmbW9ua3NjaGx0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYzNDgxMTEsImV4cCI6MjA1MTkyNDExMX0.Jv67gENX44HUQlfgQdS7moEb14iFlH6Qu6KFp9LurQ4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
